<template>
    <Modal @shown="shown" @hidden="hidden" ref="modal" modalClass="modal-md" @submit="submit">
        <template #title>
            <template v-if="office && !readonly">
                {{ i18n('Edit {name}').replace('{name}', i18n('Office')) }}
            </template>
            <template v-else-if="office">
                {{ i18n('{name} Detail').replace('{name}', i18n('Office')) }}
            </template>
            <template v-else>
                {{ i18n('Add {name}').replace('{name}', i18n('Office')) }}
            </template>
        </template>

        <div class="alert alert-danger mb-2" v-if="errorMessage">{{ errorMessage }}</div>

        <div class="row g-2">
            <div class="col-12" v-if="!company">
                <Field v-model="formData.company" :errorMessage="errorMessages.company" :label="i18n('Company')"
                    rest="companies" format="object" :disabled="submitted || !!office" :required="finallyalse"
                    :type="readonly ? 'readonly' : 'dictionary'" />
            </div>
            <div class="col-12">
                <Field v-model="formData.name" :errorMessage="errorMessages.name" :label="i18n('Name')"
                    :disabled="submitted" :required="true" :type="readonly ? 'readonly' : 'text'" />
            </div>
            <div class="col-12 mb-2">
                <AddressField :required="true" :disabled="submitted" :label="i18n('Address')" v-model="formData.address"
                    :errorMessage="errorMessages.address" :exact="true" :isCoordinatePicker="true" />
            </div>
        </div>

        <template #footer>
            <div class="row">
                <template v-if="!readonly">
                    <div class="col text-start">
                        <button type="button" class="btn btn-danger" @click="hide">
                            {{ i18n('Cancel') }}
                        </button>
                    </div>
                    <div class="col text-end">
                        <button type="submit" class="btn btn-primary text-white" :disabled="submitted">
                            {{ i18n('Confirm') }}
                        </button>
                    </div>
                </template>
                <div class="col text-end" v-else>
                    <button type="button" @click="hide" class="btn btn-outline-dark btn-sm me-2">
                        {{ i18n('Close') }}
                    </button>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import api from "@/api.js";
import { duplicate, } from "@/tools/object.js";
import Modal from "@/components/common/layout/Modal.vue";
import Field from "@/components/common/form/Field.vue";
import AddressField from "@/components/common/form/AddressField.vue";
import { translatedErrorMessage, } from "@/tools/errorHandling.js";

export default {
    components: {
        Modal,
        Field,
        AddressField,
    },
    props: {
        company: {
            type: Object,
        },
    },
    data() {
        return {
            officeId: null,
            office: null,
            submitted: false,
            formData: {},
            errorMessages: {},
            errorMessage: '',
        };
    },
    emits: [
        'shown',
        'hidden',
        'created',
        'updated',
    ],
    computed: {
        companyId() {
            return this.company?.id || this.formData?.company?.id;
        },
        readonly() {
            return this.office && this.office.acl?.update !== true;
        },
    },
    methods: {
        show(officeId) {
            this.officeId = officeId;
            this.office = null;
            this.load().then(() => {
                this.submitted = false;
                this.$refs['modal'].show();
                this.errorMessages = {};
                this.errorMessage = '';

                if (this.office) {
                    this.formData = duplicate(this.office);
                } else {
                    this.formData = {};
                }
            });
        },
        load() {
            if (!this.officeId) return Promise.resolve();
            let promise = api.get(`offices/${this.officeId}`, { acl: 'office' });

            promise.then(office => {
                this.office = office;
            });

            return promise;
        },
        hide() {
            this.$refs['modal'].hide();
        },
        shown() {
            this.$emit('shown');
        },
        hidden() {
            this.$emit('hidden');
        },
        submit() {
            this.submitted = true;
            this.errorMessages = {};
            this.errorMessage = '';

            const postFormData = duplicate(this.formData);
            let savePromise;

            if (!this.office) {
                if (this.companyId) {
                    savePromise = api.post(`companies/${this.companyId}/offices`, postFormData);
                }
                else {
                    savePromise = api.post(`offices`, postFormData);
                }
            } else {
                if (this.companyId) {
                    savePromise = api.put(`companies/${this.companyId}/offices/${this.office.id}`, postFormData);
                }
                else {
                    savePromise = api.put(`offices/${this.office.id}`, postFormData);
                }
            }

            savePromise.then(office => {
                if (!this.office) {
                    this.$emit('created', office);
                } else {
                    this.$emit('updated', office);
                }

                this.hide();
                api.clearCache();
            }).catch((errorMessage) => {
                this.errorMessage = translatedErrorMessage(errorMessage);
                this.submitted = false;
            });
        }
    }
}
</script>